import { Component, Host, h, Element, Prop } from '@stencil/core';
import { addIntersectionObserver } from '../../utils/utils';


@Component({
  tag: 'article-navigation',
  styleUrl: 'article-navigation.css',
  shadow: false,
})
export class ArticleNavigation {
  @Element() el: HTMLElement;
  private isSticky = false;
  private isAtBottom = false;

  /**
   * Main Title
   */
  @Prop() mainTitle: string;

  navScroll(filledSections) {
    //Take the nav options and set them to active and inactive depending on what section the user is scrolled into
    var navOptions = this.el.querySelectorAll('.nav-option');
    var oldActiveItems = this.el.querySelectorAll('.nav-option.is-active');
    var bannerPosition = document.querySelector('.banner-grid-article-container');
    var currentSection: HTMLElement;
    //Check each elements distance from top of screen to set nav to active.
    for (let i = 0; i < filledSections.length; i++) {
      currentSection = filledSections[i];
      if (i + 1 < filledSections.length) {
        if (i === 0 && currentSection.getBoundingClientRect().bottom <= (bannerPosition as HTMLElement).offsetHeight && currentSection.getBoundingClientRect().bottom > 500) {
          oldActiveItems.forEach((oldActiveItem, _index) => {
            oldActiveItem.classList.remove('is-active');
          });
          navOptions[i].classList.add('is-active');
        } else if (currentSection.getBoundingClientRect().top <= 100 && currentSection.getBoundingClientRect().top > 0) {
          oldActiveItems.forEach((oldActiveItem, _index) => {
            oldActiveItem.classList.remove('is-active');
          });
          navOptions[i].classList.add('is-active');
        }
      } else {
        if (currentSection.getBoundingClientRect().top <= 100) {
          oldActiveItems.forEach((oldActiveItem, _index) => {
            oldActiveItem.classList.remove('is-active');
          });
          navOptions[i].classList.add('is-active');
        }
      }
    }

    //check if nav needs to be stopped
    const sideNav = this.el.querySelector('.blog-side-nav') as HTMLElement;
    const flexibleContent = document.querySelector('.article-content-wrapper') as HTMLElement;

    const navTop = sideNav.offsetTop;
    const navHeight = sideNav.offsetHeight;
    const contentBottom = flexibleContent.offsetTop + flexibleContent.offsetHeight;

    if (!this.isSticky && window.scrollY >= navTop) {
      sideNav.style.position = 'sticky';
      this.isSticky = true;
    } else if (this.isSticky && window.scrollY < navTop) {
      sideNav.style.position = 'static';
      this.isSticky = false;
    }

    if (!this.isAtBottom && window.scrollY >= contentBottom - navHeight) {
      // sideNav.style.position = 'absolute';
      // sideNav.style.top = `-100px`;
      this.isAtBottom = true;
    } else if (this.isAtBottom && window.scrollY < contentBottom - navHeight) {
      sideNav.style.position = 'sticky';
      this.isAtBottom = false;
    }
  }

  sideNavigation() {
    const titles = document.querySelectorAll('.body-text h2');
    var sideNav = document.querySelector('.blog-side-nav-container');
    var filledSections = [];
    var index = 0;

    titles.forEach(title => {
      // Generate a unique ID based on the text content and index
      const id = `${title.textContent.replace(/\s+/g, '-').toLowerCase()}`;

      // Add the ID to the H2 element
      title.id = id;
    });

    for (var i = 0; i < titles.length; i++) {
      filledSections[index] = titles[i]; //populate the filled nav array
      index++;
      sideNav.innerHTML += `<li><a class='nav-option' href='#${titles[i].id}'  data-section='${titles[i].id}'>${titles[i].innerHTML}</a></li>`;
    }
    //console.log('title', titles);

    window.onscroll = () => this.navScroll(filledSections);
  }

  componentDidLoad() {
    window.setTimeout(() => {
      this.sideNavigation();
      addIntersectionObserver(
        this.el.querySelector('.blog-side-nav'),
        () => {
          this.el.querySelector('.blog-side-nav').classList.add('animate');
        },
        ['.overlay1'],
      );
    }, 300);
  }
  render() {
    return (
      <Host>
        <section class="blog-side-nav">
          <div class={`overlay1`}></div>
          <div class="blog-side-nav-title-container">
            <p class={`fs-0 text-ui-gray-1 font-semibold`}>{ this.mainTitle }</p>
          </div>

          <div class="blog-side-nav-container-mobile">
            <ul class="blog-side-nav-container"></ul>
          </div>
        </section>
        <slot></slot>
      </Host>
    );
  }
}
